<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ویرایش
            <strong v-text="$lang.competency"></strong>
          </div>
          <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.caption"
              label-for="name"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.caption"
                :rules="$v.name.$params"
              />
              <b-form-input
                type="text"
                :autocomplete="$lang.caption"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                v-model="$v.name.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="name-feedback"
                >{{ $lang.error_required | replace($lang.caption) }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              :label="$lang.definition_competence"
              label-for="description"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.definition_competence"
                :rules="$v.description.$params"
              />
              <b-form-textarea
                name="description"
                :state="$v.description.$dirty ? !$v.description.$error : null"
                v-model="$v.description.$model"
                type="text"
                :autocomplete="$lang.definition_competence"
                :rows="this.$config.form.textareaRows"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="description-feedback">
                {{
                  $lang.error_required | replace($lang.definition_competence)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
            <TagComponent
              category_name="competency_reference"
              :label="$lang.reference"
              :parentPermissions="permission"
              :parentValue="reference_selected"
              :requiredLabel="referenceSelectedRequired"
              :checkValidation="referenceSelectedCheckValidation"
              @updateCheckValidation="referenceSelectedUpdateCheckValidation"
              @getSelected="getReferenceSelected"
            />
            <TagComponent
              category_name="competency_category"
              :label="$lang.category"
              :parentPermissions="permission"
              :parentValue="category_selected"
              :requiredLabel="categorySelectedRequired"
              :checkValidation="categorySelectedCheckValidation"
              @updateCheckValidation="categorySelectedUpdateCheckValidation"
              @getSelected="getCategorySelected"
            />
            <b-form-group
              :label="$lang.status"
              label-for="is_enable"
              :label-cols="12"
            >
              <b-form-radio-group
                id="is_enable"
                :autocomplete="$lang.status"
                v-model="$v.is_enable.$model"
                :state="$v.is_enable.$dirty ? !$v.is_enable.$error : null"
                :options="is_enable_options"
                buttons
                button-variant="outline-primary"
                size="md"
                name="radio-btn-outline"
              ></b-form-radio-group>
            </b-form-group>
            <div slot="footer" class="form-group form-btn">
              <b-button
                class="mr-2"
                variant="outline-danger"
                @click="handleBack"
              >
                <mdicon name="close" size="20" />
                {{ $lang.cancelButton }}
              </b-button>
              <b-button
                type="submit"
                variant="success"
                v-if="isAdmin(permission)"
              >
                <mdicon name="check" size="20" />
                {{ $lang.submitButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import TagComponent from "@/components/tag/tagComponent.vue";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "edit-competency",
  inject: ["competencyRepository", "enumRepository"],
  components: {
    LoadingSpinner,
    TagComponent,
  },
  validations: {
    name: {
      required,
    },
    description: {
      required,
    },
    is_enable: {
      required,
    },
  },
  props: {
    // نمایانگر مسیر بازگشت پس از انجام یا لغو عملیات کامپوننت
    backUrl: {
      type: String,
      // null
      default: "",
    },
  },
  data() {
    return {
      isLoading: false, // دیفالت مقدار مودال false است
      id: this.$route.params.id, // آیدی که از یورل فرستاده شده
      name: "", // عنوان
      description: "", // توضیحات
      category_options: [], // ساختن دیتا لازم برای ایجاد مولتی سلکت
      reference_options: [], // ساختن دیتا لازم برای ایجاد مولتی سلکت
      category_selected: null, // دسته بندب انتخاب شده
      reference_selected: null, // مرجع انتخاب شده
      categoryLoading: false, // مودال در دسته بندی
      referenceLoading: false, // مودال در مرجع
      permission: [], // مجوز‌ها برای نمایش دکمه‌ها
      allowPermissions: ["admin", "edit"], // مجوز‌های مورد قبول
      showPermissionButton: false, // نمایش یا عدم نمایش دکمه‌ها
      is_enable_options: [], // آیتم‌های وضعیت
      is_enable: null, // وضعیت
      loadingSpinnerText: this.$lang.receiving_data,
      referenceSelectedRequired: true,
      referenceSelectedCheckValidation: false,
      categorySelectedRequired: true,
      categorySelectedCheckValidation: false,
    };
  },
  created() {
    this.isLoading = true;
    this.categoryLoading = true;
    this.referenceLoading = true;
    this.getValue();
    this.fetchData().then(() => this.PermissionButtons());
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    handleBack() {
      if (this.isModal) {
        // برای بسته شدن مودال
        // @arg بدون پارامتر
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.description = "";
      this.category_selected = null;
      this.reference_selected = null;
    },
    /**
     * @vuese
     * بعد از خیره داده ایا به یک روت قبل خود برود یا نه
     * @arg بدون پارامتر
     */
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.referenceSelectedCheckValidation = true;
      this.categorySelectedCheckValidation = true;
      this.$v.$touch();
      if (this.$v.$anyError) return;
      if (this.referenceSelectedRequired && !this.reference_selected) return;
      if (this.categorySelectedRequired && !this.category_selected) return;
      try {
        this.loadingSpinnerText = this.$lang.sending_data;
        this.isLoading = true;
        const payload = {
          name: this.name,
          description: this.description,
          category_id: pathOr(null, ["value"], this.category_selected),
          reference_id: pathOr(null, ["value"], this.reference_selected),
          is_enable: this.is_enable,
        };
        const response = await this.competencyRepository.edit(this.id, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * @vuese
     *    برای گرفتن دیتا‌های فعال غیر فعال
     * @arg بدون پارامتر
     */
    getValue() {
      let values;

      values = [
        {
          value: 1,
          text: "فعال",
        },
        {
          value: 0,
          text: "غیرفعال",
        },
      ];

      this.is_enable_options = values;
    },
    /**
     * @vuese
     *    برای گرفتن دیتا‌های صفحه شایستگی بر اساس آیدی شخص
     * @arg بدون پارامتر
     */
    fetchData() {
      if (isNaN(this.$route.params.id)) {
        this.$notify.error("Not a number!");
        return false;
      }
      this.loadingSpinnerText = this.$lang.receiving_data;

      return this.competencyRepository
        .find(this.$route.params.id)
        .then((response) => {
          let data = response.data.data;

          this.permission = response.data.permissions;
          this.name = data.name;
          this.is_enable = data.is_enable;
          this.description = data.description;
          this.isLoading = false;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        });
    },
    /**
     * @vuese
     * برای چک کردن مجوز‌های لازم جهت چک کردن نمایش یا عدم نمایش دکمه‌ها
     * @arg بدون پارامتر
     */
    PermissionButtons() {
      this.permission.map((x) => {
        if (this.allowPermissions.includes(x)) {
          this.showPermissionButton = true;
        }
      });
    },
    referenceSelectedUpdateCheckValidation(data) {
      this.referenceSelectedCheckValidation = data;
    },
    getReferenceSelected(data) {
      this.reference_selected = data;
    },
    categorySelectedUpdateCheckValidation(data) {
      this.categorySelectedCheckValidation = data;
    },
    getCategorySelected(data) {
      this.category_selected = data;
    },
  },
};
</script>

